(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rittencom_card-color-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rittencom-card-color-picker-loader')) {
    customElements.define('rittencom-card-color-picker-loader', class extends HTMLElement {
      connectedCallback() {
        const loadScript = () => {
          if (document.querySelector('[data-rittencom-card-color-js]')) return;
          const script = document.createElement('script');
          script.src = this.dataset.js;
          script.setAttribute('data-rittencom-card-color-js', '');
          document.head.append(script);
        };
        let style = document.querySelector('[data-rittencom-card-color-css]');
        if (!style) {
          style = document.createElement('link');
          style.rel = 'stylesheet';
          style.href = this.dataset.css;
          style.setAttribute('data-rittencom-card-color-css', '');
          style.addEventListener('load', loadScript, { once: true });
          document.head.append(style);
        } else if (style.sheet) {
          loadScript();
        } else {
          style.addEventListener('load', loadScript, { once: true });
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
